import { Injectable, NgZone } from '@angular/core';

import { Router } from "@angular/router";

import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore, AngularFirestoreDocument, DocumentChangeAction } from '@angular/fire/firestore';
import { AuthenticationService } from './authentication.service';
import { Config } from "./../model/config";
import { of, Observable } from 'rxjs';
import { CreateGameModel } from '../model/createGameModel';
import { QuestionModel } from '../model/questionModel';
import { ScoreModel } from '../model/scoreModel';
import { QuestionPointModel } from '../model/questionPointModel';
import { AngularFireFunctions } from '@angular/fire/functions';
import { map } from 'rxjs/operators';

import { UtilityService } from './utility.service';
import { NicknamePage } from '../home/pages/nickname/nickname.page';


@Injectable({
  providedIn: 'root'
})

export class ServerService {

  
  newUUIDball:string;
  yearValue: string;
  sourceValue: string;
  
  regole:any;
  constructor(
    public afStore: AngularFirestore,
    public ngFireAuth: AngularFireAuth,
    public router: Router,
    public ngZone: NgZone,
    private authSrv: AuthenticationService,
    private firebaseFunction: AngularFireFunctions
  ) {
 /*
    this.authSrv.ngFireAuth.onAuthStateChanged(function(user) {
      if (user) {
        if(user.emailVerified){
          if(authSrv.config.googleSession){
            utilitySrv.showLoading();
            authSrv.initRealUser(user).subscribe(res=>{
              utilitySrv.hideLoading();
  
            });
          }
        }else{
          this.authService.SignOut();
        }
        
        
       } else {
        
        authSrv.initUser();
      }
    });
    */
  }

  addOrRemoveUserAsAdmin(nickname: string, isAdmin: boolean): Observable<any> {
    var callable = this.firebaseFunction.httpsCallable('setUserAdmin');

    return callable({nickname: nickname, admin: isAdmin}).pipe(map(result => {
      console.log('call setUserAdmin server:', result);
      return result;
    }, error => {
      console.log('call setUserAdmin server:', error);
      return error;
    }));
  }

  registrationFunction(nickname):Observable<any> {
    var addMessage =  this.firebaseFunction.httpsCallable('setNickname');
    return addMessage({nickname: nickname}).pipe(map(result => {
      return result; 
    },error=>{
      return error;
    }));  
  }

  getAnalytics(): Observable<any> {
    let addMessage = this.firebaseFunction.httpsCallable('getStats');
    return addMessage({}).pipe(map(result => {
      return result;
    }, error => {
      return error;
    }));
  }

  getAnalyticsDownload(): Observable<any> {
    let addMessage = this.firebaseFunction.httpsCallable('getCSVStats');
    return addMessage({}).pipe(map(result => {
      return result;
    }, error => {
      return error;
    }));
  }

  startMatchmakingFunction(difficulty) {
    const callable = this.firebaseFunction.httpsCallable('startMatchmaking');

    return callable({difficulty: difficulty}).pipe(map(result => {
      return result;
    }, error => {
      return error;
    }));
  }


  startConfirmMatch(difficulty) {
    const callable = this.firebaseFunction.httpsCallable('confirmMatch');
    return callable({difficulty : difficulty}).pipe(map(result => {
      console.log('call confirmMatch server:', result);
      return result; 
    },error=>{
      console.log('call confirmMatch server error:', error);
      return error;
    }));  
  }

  endMatchmakingFunction(difficulty) {
    const callable = this.firebaseFunction.httpsCallable('stopMatchmaking');
    return callable({difficulty: difficulty}).pipe(map(result => {
      console.log('call stopMatchmaking server:', result);
      return result; 
    },error=>{
      console.log('call stopMatchmaking server error:', error);
      return error;
    })); 
  }

  endQualificationFunction(idTorneo:string) :Observable<any> {
    
    var addMessage =  this.firebaseFunction.httpsCallable('endQualification');
    return addMessage({tournamentId : idTorneo}).pipe(map(result => {
      console.log('call endQualificationFunction server:', result);
      return result; 
    },error=>{
      console.log('call endQualificationFunction server error:', error);
      return error;
    }));  
  }
 
  endRoundFunction(idTorneo:string) :Observable<any> {
    var addMessage =  this.firebaseFunction.httpsCallable('endRound');
    return addMessage({tournamentId : idTorneo}).pipe(map(result => {
      console.log('call endRoundFunction server:', result);
      return result; 
    },error=>{
      console.log('call endRoundFunction server error:', error);
      return error;
    }));  
  }

  startRoundFunction(idTorneo:string,startDelay:number=null) :Observable<any> {
    var addMessage =  this.firebaseFunction.httpsCallable('startRound');
    return addMessage({tournamentId : idTorneo,startDelay:startDelay}).pipe(map(result => {
      console.log('call startRoundFunction server:', result);
      return result; 
    },error=>{
      console.log('call startRoundFunction server error:', error);
      return error;
    }));  
  }

  createGameBotFunction(idTorneo: string = null, value): Observable<CreateGameModel> {
      var addMessage =  this.firebaseFunction.httpsCallable('createMatch');
      return addMessage({tournamentId : idTorneo, difficulty: value}).pipe(map(result => {
        console.log('call createGameBotFunction server:', result);
        return result;
      },error=>{
        console.log('call createGameBotFunction server error:', error);
        return error;
      }));
  }

  getQuestionFunction(idGame: string, difficulty: string, idTournament: string = null, idTurn: string = null, yr: string, src: string): Observable<QuestionModel> {
    console.log('call getQuestionFunction');
    var addMessage =  this.firebaseFunction.httpsCallable('getQuestion');
    return addMessage({matchId  : idGame,tournamentId:idTournament,roundId:idTurn, year: yr, source: src, difficulty: difficulty}).pipe(map(result => {
        console.log('call getQuestionFunction server:', result);
        this.yearValue = result.year;
        this.sourceValue = result.source;
        return result;
      },error=>{
        console.log('call getQuestionFunction server error:', error);
        return error;
      }));
  }

  getScoreFunction(idGame: string, difficulty: string, idTournament: string = null, idTurn: string = null): Observable<ScoreModel> {
        var addMessage =  this.firebaseFunction.httpsCallable('getScore');
        return addMessage({ matchId: idGame, tournamentId: idTournament, roundId: idTurn, difficulty: difficulty}).pipe(map(result => {
          console.log('call getScore server:', result);
          
          return result; 
        },error=>{
          console.log('call getScore server error:', error);
          return error;
        }));
  }

  questionPointFunction(questionId: string, idGame: string, difficulty: string, idTournament: string = null, idTurn: string = null): Observable<QuestionPointModel> {
      var addMessage =  this.firebaseFunction.httpsCallable('getPointResult');
      return addMessage({ questionId: questionId, matchId: idGame, tournamentId: idTournament, roundId: idTurn, difficulty: difficulty}).pipe(map(result => {
        console.log('call getPointResult server:', result);
        return result;
      },error=>{
        console.log('call getPointResult server error:', error);
        return error;
      }));
  }

  setAnswerFunction(idQuestion: string, idAnswer: string, idGame: string, difficulty: string, idTournament: string = null, idTurn: string = null): Observable<any> {
      var addMessage =  this.firebaseFunction.httpsCallable('sendAnswer');
      return addMessage({questionId: idQuestion, answerId: idAnswer, matchId: idGame, tournamentId: idTournament, roundId: idTurn, difficulty: difficulty}).pipe(map(result => {
        console.log('call setAnswerFunction server:', result);
        
        return result; 
      },error=>{
        console.log('call setAnswerFunction server error:', error);
        return error;
      }));  
      
  }


  getInfo(): Observable<DocumentChangeAction<any>[]> {    
    return this.afStore.collection('info').snapshotChanges();
  
  }

  getInfoGioco(): Observable<DocumentChangeAction<any>[]> {
    return this.afStore.collection('infoGame').snapshotChanges();
  
  }

  getRoles() {
    return this.afStore.collection('regole').snapshotChanges();
  }


  isNickName():Observable<boolean>{
    if(this.authSrv.user.isNickname){
      return of(true);
    }
    return this.authSrv.getUser().get().pipe(map(doc => {
      if(doc && doc.data()){
        
        let nickname:string =doc.data().nickname;
        this.authSrv.user.isNickname=(nickname && nickname.trim().length>0);
        return this.authSrv.user.isNickname;
      }
     }));
  }

  getPlayersLadderByUuid(uuid:string):AngularFirestoreDocument<any> {
    return this.afStore.collection('tournaments').doc(this.authSrv.config.tournamentId).collection("playersLadder").doc(uuid);
  } 

  
  isGameDone():Observable<boolean>{
    if(this.authSrv.user.isGameDone){
      return of(true);
    }
    return this.getPlayersLadderByUuid(this.authSrv.user.uid).get().pipe(map(doc => {
      if(doc && doc.data()){
        this.authSrv.user.isGameDone=true;
      }else{
        this.authSrv.user.isGameDone=false;
      }
        return this.authSrv.user.isGameDone;
     }));
    }  
    
  getMatchInformation():Observable<any>{
    return this.afStore.collection('tournaments').snapshotChanges();
  }

  getMatchInformationById(currentTournament:string):Observable<any>{
    return this.afStore.collection('tournaments').doc(currentTournament).snapshotChanges();
  }

  getTournament():Observable<any>{
    return this.afStore.collection('tournaments').get();
  }

  getTournamentById(currentTournament:string):Observable<any>{
    return this.afStore.collection('tournaments').doc(currentTournament).get();
  }

  getSnapshotResultPoint(currentRound:string,matchId:string):Observable<any>{
    return this.afStore.collection('tournaments').doc(this.authSrv.config.tournamentId).collection('rounds').doc(currentRound).collection('matches').doc(matchId).collection('questionsHistory', ref => ref.orderBy('questionId', 'desc')).snapshotChanges();
  }

  sendInvite(difficulty: string, nickname: string) :Observable<any> {
    var send =  this.firebaseFunction.httpsCallable('sendInvite');
    return send({difficulty: difficulty, nickname: nickname}).pipe(map(result => {
      console.log('call sendInvite server: ', result);
      return result; 
    },error=>{
      console.log('call sendInvite server error: ', error);
      return error;
    }));  
  }

  respondInvite(inviteId: string, response: string, reason: string = null) :Observable<any> {
    var send =  this.firebaseFunction.httpsCallable('respondToInvite');
    return send({inviteId: inviteId, response: response, reason: reason}).pipe(map(result => {
      console.log('call respondToInvite server: ', result);
      return result; 
    },error=>{
      console.log('call respondToInvite server error: ', error);
      return error;
    }));  
  }
  
}
